import logUtil from 'utils/log'

export default function replaceStateHistoryUtil (url) {
  logUtil('replaceStateHistoryUtil').debug(`url=${url}`)
  window.history.replaceState({ path: url }, '', url)
}
